export default __webpack_public_path__ + "static/media/ridevuLogo.0d8c7979.svg";